import { render, staticRenderFns } from "./view.html?vue&type=template&id=6a6a1d10&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./otherStyle.less?vue&type=style&index=0&lang=less&"
import style1 from "./style.less?vue&type=style&index=1&id=6a6a1d10&scoped=true&lang=less&"
import style2 from "./style_notebook.less?vue&type=style&index=2&id=6a6a1d10&scoped=true&lang=less&"
import style3 from "./style_mobile.less?vue&type=style&index=3&id=6a6a1d10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a1d10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a6a1d10')) {
      api.createRecord('6a6a1d10', component.options)
    } else {
      api.reload('6a6a1d10', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=6a6a1d10&scoped=true&", function () {
      api.rerender('6a6a1d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/upgrade/list/index.vue"
export default component.exports